// src/utils/lessonMetadata.js

const metadataDatabase = {
  "python": {
    "14": {
      duration: "15 min",
      difficulty: "Intermediate",
      prerequisites: "Python Basics, Functions",
      objectives: [
        "Understand the core concepts of concurrency, parallelism, and asynchronous execution.",
        "Differentiate between single-core context switching and multi-core parallelism.",
        "Identify typical I/O-bound and CPU-bound scenarios in software projects."
      ]
    },
    "14.1": {
      duration: "20 min",
      difficulty: "Beginner",
      prerequisites: "Python Basics",
      objectives: [
        "Explain what a process is and how the operating system isolates its memory space.",
        "Understand the difference between processes and threads.",
        "Explain the restaurant kitchen analogy for threads and processes."
      ]
    },
    "14.2": {
      duration: "30 min",
      difficulty: "Intermediate",
      prerequisites: "Python Functions, OOP",
      objectives: [
        "Create and manage threads using Python's built-in threading.Thread API.",
        "Differentiate between synchronous run() and asynchronous start() methods.",
        "Recognize and prevent common thread synchronization issues (race conditions, deadlocks).",
        "Implement thread-safe shared state using Locks and Semaphores."
      ]
    },
    "14.3": {
      duration: "20 min",
      difficulty: "Intermediate",
      prerequisites: "Multithreading in Python",
      objectives: [
        "Explain the Global Interpreter Lock (GIL) and its role in Python memory safety.",
        "Understand why the GIL prevents true parallel execution of CPU-bound threads in Python.",
        "Select the correct concurrency model (Multiprocessing or AsyncIO) to bypass the GIL."
      ]
    },
    "14.4": {
      duration: "25 min",
      difficulty: "Advanced",
      prerequisites: "Multithreading, GIL",
      objectives: [
        "Create child processes using Python's multiprocessing module.",
        "Utilize ProcessPoolExecutor to perform CPU-heavy parallel calculations.",
        "Establish secure Inter-Process Communication (IPC) using Queues and Pipes."
      ]
    },
    "14.5": {
      duration: "20 min",
      difficulty: "Intermediate",
      prerequisites: "Multithreading, Multiprocessing",
      objectives: [
        "Construct a detailed side-by-side comparison of threads versus processes.",
        "Analyze execution overhead, memory footprints, and state sharing characteristics.",
        "Select the optimal execution unit depending on project requirements."
      ]
    },
    "14.6": {
      duration: "25 min",
      difficulty: "Advanced",
      prerequisites: "Asynchronous execution theory",
      objectives: [
        "Explain cooperative multitasking and event-driven architectures.",
        "Write async functions using Python's async and await keywords.",
        "Compare synchronous blocking execution with non-blocking event-driven execution."
      ]
    },
    "14.7": {
      duration: "25 min",
      difficulty: "Advanced",
      prerequisites: "Async programming",
      objectives: [
        "Understand the internals of the asyncio event loop.",
        "Run concurrent tasks concurrently using asyncio.gather().",
        "Manage task cancellations and exception handling inside async coroutines."
      ]
    },
    "14.8": {
      duration: "20 min",
      difficulty: "Intermediate",
      prerequisites: "Async, Threads, Processes",
      objectives: [
        "Compare AsyncIO, Multithreading, and Multiprocessing side-by-side.",
        "Determine which concurrency tool fits best for web scrapers, REST APIs, or mathematical encoders."
      ]
    },
    "14.9": {
      duration: "30 min",
      difficulty: "Advanced",
      prerequisites: "FastAPI, SQL, Concurrency",
      objectives: [
        "Implement real-world concurrent scrapers and high-throughput workers.",
        "Avoid database connection pool starvation and rate limits when running concurrent tasks."
      ]
    }
  }
};

export function getLessonMetadata(subject, contentId, contentText = "") {
  const normSubject = (subject || "").toLowerCase();
  const subjectMeta = metadataDatabase[normSubject] || {};
  const meta = subjectMeta[contentId];

  if (meta) {
    return meta;
  }

  // Fallback: Calculate reading time and generate default metadata
  const wordCount = contentText ? contentText.replace(/<[^>]*>/g, "").split(/\s+/).length : 0;
  const calculatedMinutes = Math.max(5, Math.ceil(wordCount / 200));
  
  return {
    duration: `${calculatedMinutes} min`,
    difficulty: "Intermediate",
    prerequisites: "None",
    objectives: [
      "Understand the primary concepts introduced in this lesson.",
      "Analyze the code examples and explain their practical outcomes.",
      "Complete the check-your-understanding exercises."
    ]
  };
}
